import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
export const ChallengeProgramSectionTitle = (props) => {
    return React.createElement("div", { className: css(styles.sectionTitle) }, props.title);
};
const styles = StyleSheet.create({
    sectionTitle: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
});
